// 创建滚动条
export const createAffixScroll = that => {
    const { autoAffixScroll = false, adaptionType } = that.props;
    if (!autoAffixScroll || !that.table) {
        return;
    }
    let $tableCenter = that.table.querySelector('.u-table-body');
    if (!$tableCenter) { return; }

    let $affixScrollWrapper = that.table.querySelector('.affix-scrollbar-wrapper');
    let $affixScroll = that.table.querySelector('.affix-scrollbar');
    let bodyWidth = $tableCenter.getBoundingClientRect().width; //u-table-body 
    let scrollWidth = $tableCenter.querySelector('table').getBoundingClientRect().width; //u-table-body 下 table标签宽度

    if ($affixScrollWrapper && $affixScroll) {
        $affixScrollWrapper.style.width = `${bodyWidth}px`;
        $affixScroll.style.width = `${scrollWidth}px`;
        // 给表格上加一个标识
        if (scrollWidth - bodyWidth > 0) {
            that.table.className = that.table.className.replace(' bbq-has-scroll ', '');
            that.table.className += ' bbq-has-scroll ';
        }
        affixScrollPosition(that);
    } else {
        // 模拟滚动条
        $affixScrollWrapper = document.createElement('div');
        $affixScrollWrapper.setAttribute('class', 'affix-scrollbar-wrapper');
        $affixScrollWrapper.style.width = `${bodyWidth}px`;
        // 给表格上加一个标识
        if (scrollWidth - bodyWidth > 0) {
            that.table.className = that.table.className.replace(' bbq-has-scroll ', '');
            that.table.className += ' bbq-has-scroll ';
        }
        $affixScroll = document.createElement('div');
        $affixScroll.setAttribute('class', 'affix-scrollbar');
        $affixScroll.style.width = `${scrollWidth}px`;
        $tableCenter.parentNode.appendChild($affixScrollWrapper);
        $affixScrollWrapper.appendChild($affixScroll);
        // if (adaptionType === 'card') {
        //     // 兼容下表单样式变化
        //     setTimeout(() => {
        //         affixScrollPosition(that);
        //     }, 200);
        // } else {
        affixScrollPosition(that);
        // }
    }
};

// 定位计算
export const affixScrollPosition = that => {
    let affixScroll = that.table && that.table.querySelector('.affix-scrollbar-wrapper');
    if (!affixScroll) {
        return;
    }

    let bottom = getFirstScrollParentHeight(that);
    let $header = that.table.querySelector('.u-table-thead');
    let headerHeight = $header && $header.offsetHeight;

    let $footer = that.table.querySelector('.u-table-footer');

    // 16 以前应该是预留给滚动条的
    let footerHeight = $footer ? 29 : 0;
    // let footerHeight = $footer ? $footer.offsetHeight : 0;
    let windowHeight = window.innerHeight || 0;
    let tableTop = that.table.getBoundingClientRect().top || 0;

    let tablebodyHeight = that.table.querySelector('.u-table-body').offsetHeight
    let tableHeight = headerHeight + tablebodyHeight + footerHeight || 0;
    let bottomPosition = tableHeight - windowHeight + tableTop + bottom;
    if (
        windowHeight - tableTop - bottom > headerHeight + footerHeight / 2 && bottomPosition > 0
    ) {
        affixScroll.style.bottom = `${tableHeight - windowHeight + tableTop + bottom}px`;
        $footer && ($footer.style.opacity = '1');
        $footer && ($footer.style.top = `-${tableHeight - windowHeight + tableTop + bottom}px`);
    } else {
        affixScroll.style.bottom = '-16px';
        if (windowHeight - tableTop <= headerHeight) {
            $footer && ($footer.style.opacity = '0');
        } else {
            $footer && ($footer.style.opacity = '1');
            $footer && ($footer.style.top = '0px');
        }
    }
}

// 获取第一个父级滚动区域距离底部的距离
export const getFirstScrollParentHeight = that => {
    if (!that.table) return;

    let $parentElement = that.table.parentElement,
        $scrollElement = null,
        bottom = 0
    while ($parentElement) {
        let overflow = window.getComputedStyle($parentElement).getPropertyValue('overflow');
        // 由于dom变化  可能会导致本来没有滚动条的产生滚动条  所以所有dom都要加下这个逻辑
        if ($parentElement.scrollHeight > $parentElement.clientHeight && overflow == 'auto') {
            $scrollElement = $parentElement;
            break;
        }

        $parentElement = $parentElement.parentElement;
        // parent 目前不做处理  不再循环  让bottom为0
        if ($parentElement === document.body) { break }
    }
    if ($scrollElement) {
        let windowHeight = window.innerHeight || 0;
        let top = $scrollElement.getBoundingClientRect().top || 0;
        let height = $scrollElement.offsetHeight || 0;
        bottom = windowHeight - top - height;
    }
    return bottom > 0 ? bottom : 0;
}